import { ReactElement, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { driver, Driver } from 'driver.js';
import 'driver.js/dist/driver.css';

type Step = {
  element: string;
  title: ReactElement | string;
  description: ReactElement | string;
};

type DriverTourProps = {
  start: boolean;
  onClose?: () => void;
  steps: Step[];
};

export default function DriverTour({ start, onClose, steps }: DriverTourProps) {
  const tourRef = useRef<Driver | null>(null);

  useEffect(() => {
    if (!start) return;
    if (!tourRef.current) {
      tourRef.current = driver({
        allowClose: true,
        doneBtnText: 'Done',
        onDestroyStarted: () => {
          tourRef.current?.destroy();
          tourRef.current = null;
          onClose?.();
        },
        onPopoverRender: (element, opts) => {
          if (
            Number.isNaN(opts?.state?.activeIndex) ||
            Number(opts?.state?.activeIndex) >= steps.length
          ) {
            return;
          }

          const title = document.querySelector('#driver-popover-title');
          const desc = document.querySelector('#driver-popover-description');

          if (title) {
            const titleNode = ReactDOM.createRoot(title);
            titleNode.render(steps[Number(opts.state.activeIndex)].title);
          }
          if (desc) {
            const descNode = ReactDOM.createRoot(desc);
            descNode.render(steps[Number(opts.state.activeIndex)].description);
          }
        },
      });

      tourRef.current.setSteps(
        steps.map((step) => ({
          element: step.element,
          popover: {
            title: 'PLACEHOLDER',
            description: 'PLACEHOLDER',
          },
        })),
      );
    }

    tourRef.current.drive();
  }, [steps, onClose, start]);

  return null;
}
